import { Component } from 'react'
import ReactDOM from 'react-dom'
import Button from '../../Nodes/Button'
import Icon from '../../Nodes/Icon'

class Fab extends Component {
    constructor(props) {
        super(props)
        this.containerEl = document.createElement('div')
        this.containerEl.classList.add('fab')
        // maybe needs to inherit classlist from props, for future hiding
    }

    renderBtn = () => {
        let { className, children,  ...remainingProps } = this.props
        className = className ? className + ' fab__btn' : 'fab__btn'

        return (
            <Button 
                raised 
                className={className} 
                {...remainingProps}>
                <Icon>{children}</Icon>
            </Button>
        )
    }

    render() {
        return ReactDOM.createPortal(
            this.renderBtn(),
            this.containerEl)
    }

    componentDidMount() {
        document.body.appendChild(this.containerEl)
    }

    componentWillUnmount() {
        document.body.removeChild(this.containerEl)
    }
}

export default Fab